import { removeCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import {
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import { SettingsCollectionModel } from "@insite/client-framework/Services/SettingsService";

export interface UpdateContextModel {
    languageId?: string | null;
    currencyId?: string | null;
    fulfillmentMethod?: string | null;
    billToId?: string | null;
    shipToId?: string | null;
    settings?: SettingsCollectionModel;
    pickUpWarehouseId?: string | null;
}

export function updateContext(context: UpdateContextModel) {
    if (IS_SERVER_SIDE) {
        return;
    }

    stopWatchingForOtherTabSessionChange(); // Prevent reload from the changes we're doing here.

    const secure = window.location.protocol === "https";

    if (typeof context.languageId !== "undefined") {
        if (context.languageId === null) {
            removeCookie("CurrentLanguageId");
        } else {
            setCookie("CurrentLanguageId", context.languageId, { path: "/", secure });
        }
    }

    if (typeof context.currencyId !== "undefined") {
        if (context.currencyId === null) {
            removeCookie("CurrentCurrencyId");
        } else {
            setCookie("CurrentCurrencyId", context.currencyId, { path: "/", secure });
        }
    }

    if (context.fulfillmentMethod === null) {
        removeCookie("CurrentFulfillmentMethod");
    }

    if (context.billToId === null) {
        removeCookie("CurrentBillToId");
    }

    if (context.shipToId === null) {
        removeCookie("CurrentShipToId");
    }

    if (context.pickUpWarehouseId === null) {
        removeCookie("CurrentPickUpWarehouseId");
    }

    watchForOtherTabSessionChange(); // Restart the watcher with the updated "current" state.
}
